import { Component, OnInit, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { DatePipe } from '@angular/common';
import { Observable, ReplaySubject, Subject, debounceTime, switchMap, takeUntil } from 'rxjs';
import { IconType } from '@shared/utils/icons';
import { ButtonType } from '@shared/ui/buttons';
import { BaseDateTimeService } from '@shared/utils/date-time';

@Component({
  selector: 'shared-ui-datetime-datetimepicker',
  templateUrl: './datetimepicker.component.html',
  styleUrls: ['./datetimepicker.component.css'],
  providers: [DatePipe],
  standalone: false,
})
export class DateTimePickerComponent implements OnInit, OnDestroy {
  @Input() initialDateTimeValue = new Date();

  @Output() emitDateTime: EventEmitter<Date> = new EventEmitter<Date>();

  Icon = IconType;
  Button = ButtonType;

  minDate = new Date(2015, 0, 1);
  maxDate = new Date();

  dateTime?: Date;
  dateTimeString = '';
  useMilitaryTime$!: Observable<boolean>;

  private dateTimeSet = new ReplaySubject<Date>();
  private dateTimeDebouncer = new Subject<Date>();
  private ngUnsubscribe = new Subject<void>();

  constructor(private dateTimeService: BaseDateTimeService) {}

  ngOnInit(): void {
    this.useMilitaryTime$ = this.dateTimeService.useMilitaryTime();
    this.dateTime = new Date(this.initialDateTimeValue);

    this.dateTimeDebouncer.pipe(debounceTime(500), takeUntil(this.ngUnsubscribe)).subscribe((value) => this.emitDateTime.emit(value));

    this.dateTimeSet
      .pipe(
        switchMap((value) => this.dateTimeService.formatDateTime(value)),
        takeUntil(this.ngUnsubscribe)
      )
      .subscribe((formatted) => (this.dateTimeString = formatted));

    this.dateTimeSet.next(this.dateTime);
  }

  onDateTimeChange(date: Date): void {
    if (date) {
      this.dateTime = new Date(date);
      this.dateTimeSet.next(this.dateTime);
      this.dateTimeDebouncer.next(this.dateTime);
    }
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
